<template>
    <component-wrapper :config="component" @click.native="showCheckin" />
</template>

<script>
import components from '../component.js'

export default {
    name: 'zoezi-checkin-button',
    zoezi: {
        title: 'Check-in button',
        icon: 'mdi-check'
    },
    props: {
        component: {
            title: 'Component',
            type: Object,
            fulltype: 'component',
            default: () => components.makeEmptyConfig({component: 'zoezi-button', props: {text: 'Checka in', icon: 'mdi-check'}})
        },
        checkinResources: {
            title: 'Doors to be shown at check-in',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                getItems: () => {
                    return window.$zoeziapi.get('/api/resource/get').then(resources => {
                        const doors = resources.filter(resource => resource.resourceType == 'door')
                        return doors.map(({lastname, id}) => ({name: lastname, id}));
                    })
                }
            },
            default: () => []
        },
        onlyQrCheckin: {
            title: 'Open QR scanner directly',
            type: Boolean,
            default: false
        },
    },
    methods: {
        showCheckin() {
            this.$emit('clicked');
            this.$store.commit('showCheckinDialog', { resources: this.checkinResources, onlyShowQrScanner: this.onlyQrCheckin });
        }
    },
}
</script>
